import { twMerge } from 'tailwind-merge';

import { MapIcon } from '../Icons/MapIcon';

interface IProps {
  innerClassName?: string;
}

export const StaticMapPlaceholder = ({ innerClassName = '' }: IProps) => {
  return (
    <div className="text-sea-foam absolute size-full p-4 sm:p-8">
      <div
        className={twMerge(
          `bg-lake-fog flex h-full w-full items-center justify-center rounded-lg`,
          innerClassName,
        )}
      >
        <div className="bg-disabled rounded-sm p-3">
          <MapIcon />
        </div>
      </div>
    </div>
  );
};
